import { render, staticRenderFns } from "./number-box.html?vue&type=template&id=5c8b71bd&scoped=true&"
import script from "./number-box.js?vue&type=script&lang=js&"
export * from "./number-box.js?vue&type=script&lang=js&"
import style0 from "./number-box.scss?vue&type=style&index=0&id=5c8b71bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b71bd",
  null
  
)

export default component.exports